const STORAGE_KEY = 'orcai_logs';
const MAX_LOGS = 5000;

export const ADMIN_EMAILS = [
  'teste@orcai.com',
  'ramon@quantocustaobra.com',
];

export const LOG_ACTIONS = {
  LOGIN_SUCCESS: 'login_success',
  LOGIN_FAIL: 'login_fail',
  LOGOUT: 'logout',
  REGISTER: 'register',
  UPLOAD: 'upload',
  ANALYSIS_START: 'analysis_start',
  ANALYSIS_END: 'analysis_end',
  ANALYSIS_ERROR: 'analysis_error',
  DOWNLOAD_EXCEL: 'download_excel',
  DOWNLOAD_PDF: 'download_pdf',
  VIEW_PLANS: 'view_plans',
  PAYMENT_ATTEMPT: 'payment_attempt',
  FEEDBACK_POSITIVE: 'feedback_positive',
  FEEDBACK_NEGATIVE: 'feedback_negative',
  MANUAL_ITEM_ADD: 'manual_item_add',
  CONSENT: 'consent',
  CUB_CALCULATE: 'cub_calculate',
  CUB_ADMIN_UPDATE: 'cub_admin_update',
  SINAPI_SEARCH: 'sinapi_search',
  SINAPI_VIEW_COMPOSICAO: 'sinapi_view_composicao',
  SINAPI_ADD_TO_ORCAMENTO: 'sinapi_add_to_orcamento',
  SINAPI_REMOVE_FROM_ORCAMENTO: 'sinapi_remove_from_orcamento',
  SINAPI_CALCULATE: 'sinapi_calculate',
  SINAPI_EXPORT_EXCEL: 'sinapi_export_excel',
  SINAPI_EXPORT_PDF: 'sinapi_export_pdf',
  SINAPI_IMPORT_START: 'sinapi_import_start',
  SINAPI_IMPORT_COMPLETE: 'sinapi_import_complete',
  SINAPI_IMPORT_ERROR: 'sinapi_import_error',
  ORCAMENTO_START: 'orcamento_start',
  ORCAMENTO_ANALISE: 'orcamento_analise',
  ORCAMENTO_VALIDACAO: 'orcamento_validacao',
  ORCAMENTO_CALCULO: 'orcamento_calculo',
  ORCAMENTO_EXPORT: 'orcamento_export',
};

function getCurrentUser() {
  try {
    const data = localStorage.getItem('orcai_user');
    return data ? JSON.parse(data) : null;
  } catch {
    return null;
  }
}

function loadLogs() {
  try {
    const data = localStorage.getItem(STORAGE_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

function saveLogs(logs) {
  try {
    const trimmed = logs.slice(0, MAX_LOGS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch (e) {
    if (e.name === 'QuotaExceededError' || e.code === 22) {
      const reduced = logs.slice(0, Math.floor(MAX_LOGS * 0.8));
      localStorage.setItem(STORAGE_KEY, JSON.stringify(reduced));
    }
  }
}

const LogService = {
  log(action, options = {}) {
    const user = getCurrentUser();
    const entry = {
      id: `${Date.now()}-${Math.random().toString(36).substring(2, 8)}`,
      timestamp: new Date().toISOString(),
      user_id: options.userId || user?.id || 'anonymous',
      user_email: options.userEmail || user?.email || 'anonymous',
      action,
      details: options.details || {},
      ip_address: 'client-side',
      user_agent: navigator.userAgent,
      status: options.status || 'success',
      error_message: options.errorMessage || null,
    };

    const logs = loadLogs();
    logs.unshift(entry);
    saveLogs(logs);
    return entry;
  },

  getAll() {
    return loadLogs();
  },

  getFiltered(filters = {}) {
    let logs = loadLogs();

    if (filters.startDate) {
      const start = new Date(filters.startDate);
      logs = logs.filter((l) => new Date(l.timestamp) >= start);
    }
    if (filters.endDate) {
      const end = new Date(filters.endDate);
      end.setHours(23, 59, 59, 999);
      logs = logs.filter((l) => new Date(l.timestamp) <= end);
    }
    if (filters.userEmail) {
      const search = filters.userEmail.toLowerCase();
      logs = logs.filter((l) => l.user_email.toLowerCase().includes(search));
    }
    if (filters.action) {
      logs = logs.filter((l) => l.action === filters.action);
    }
    if (filters.status) {
      logs = logs.filter((l) => l.status === filters.status);
    }

    return logs;
  },

  isAdmin(email) {
    return ADMIN_EMAILS.includes(email?.toLowerCase());
  },

  clearAll() {
    localStorage.removeItem(STORAGE_KEY);
  },
};

export default LogService;
